export const TARGET_DOMAINS = [
  "app.notion.com",
  "img.notionusercontent.com",
  "msgstore-002.app.notion.com",
  "identity.notion.com",
  "exp.notion.com",
  "audioprocessor.app.notion.com",
] as const;

export type HostTestResult = {
  ip: string;
  average: number | null;
  status: string;
};

export function generateHostsFileContent(
  testResults: HostTestResult[]
): string {
  const completedResults = testResults.filter(
    (result) => result.status === "complete" && result.average !== null
  );

  if (completedResults.length === 0) {
    return "";
  }

  const fastest = completedResults.reduce((min, result) =>
    result.average < min.average ? result : min
  );

  return TARGET_DOMAINS.map((domain) => `${fastest.ip} ${domain}`).join("\n");
}
